import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {useUser} from '@deezer/react-user';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useAuthLink} from '@app/hooks/use-link';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'd5570b53f32ea79d164a16a27f979052.png',
	fr: 'b5e67c0a6f564b18b369ee7c3fff7e5b.png',
};

export const FlowHero: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	const {getRegistrationLink} = useAuthLink();
	const [user] = useUser();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h1"
						dangerouslySetInnerHTML={{
							__html: t(
								'flowlandingpage_title_yourpersonalizedinfinitemix_standalone-web',
								{ns: 'flow'},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'flowlandingpage_text_yourpersonalizedinfinitemixV2_standalone-web',
							{ns: 'flow'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'signup'}}
						href={
							user?.isConnected()
								? getDeezerUrl('/open_app?page=flow')
								: getRegistrationLink()
						}
						isMain
					>
						{t('generic_action_tryflow_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					alt={t('metatag_text_musicbasedonyourmood_standalone-web', {
						ns: 'common',
					})}
					quality={90}
					objectFit={{base: 'cover', sm: 'contain'}}
					aspectRatio="1440/420"
					src={src}
					priority
				/>
			}
		/>
	);
};
